import { render, staticRenderFns } from "./BsiContinuousFilingTask.vue?vue&type=template&id=89a1ba1a&scoped=true&"
import script from "./BsiContinuousFilingTask.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingTask.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingTask.vue?vue&type=style&index=0&id=89a1ba1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a1ba1a",
  null
  
)

export default component.exports